import { DashboardWidget, LayoutConfig } from "@sanity/dashboard";
import {
  LandProgrammeExporter,
  LandProgrammeExporterProps
} from "./LandProgrammeExporter";

export function landProgrammeExporter<T>(
  config: { layout?: LayoutConfig } & LandProgrammeExporterProps<T>
): DashboardWidget {
  return {
    name: "land-programme-exporter",
    component: () => (
      <LandProgrammeExporter
        query={config.query}
        title={config.title}
        mapResult={config.mapResult}
      />
    ),
    layout: config.layout ?? { width: "medium" }
  };
}
